export default __webpack_public_path__ + "static/media/close.35026380.svg";